/**
 * Utility per loggare errori in modo strutturato
 */

export const logError = (error, context = {}) => {
    const errorLog = {
        timestamp: new Date().toISOString(),
        message: error?.message || String(error),
        stack: error?.stack,
        context: context,
        windowEnv: window.env,
        userAgent: navigator.userAgent,
        url: window.location.href
    };
    
    console.error('🚨 ERRORE:', errorLog);
    
    // Puoi anche inviare l'errore a un servizio di logging
    // fetch('/api/logs/error', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(errorLog)
    // }).catch(() => {});
    
    return errorLog;
};

export const logApiError = (error, apiCall) => {
    const errorLog = {
        timestamp: new Date().toISOString(),
        type: 'API_ERROR',
        apiCall: apiCall,
        status: error?.response?.status,
        statusText: error?.response?.statusText,
        data: error?.response?.data,
        message: error?.message,
        config: {
            url: error?.config?.url,
            method: error?.config?.method,
            headers: error?.config?.headers
        },
        windowEnv: window.env
    };
    
    console.error('🚨 ERRORE API:', errorLog);
    return errorLog;
};

// Funzione per testare gli errori (da chiamare dalla console)
window.testError = () => {
    console.log('🧪 Test error handler...');
    throw new Error('Test error - questo è un errore di test');
};

window.testPromiseError = () => {
    console.log('🧪 Test promise rejection...');
    Promise.reject(new Error('Test promise rejection'));
};

window.testEnvError = () => {
    console.log('🧪 Test window.env...');
    const originalEnv = window.env;
    window.env = undefined;
    console.log('window.env rimosso temporaneamente');
    setTimeout(() => {
        window.env = originalEnv;
        console.log('window.env ripristinato');
    }, 2000);
};

window.showEnvConfig = () => {
    console.log('📋 Configurazione corrente:');
    console.table(window.env || { error: 'window.env non definito' });
    console.log('env-config.js URL:', `${window.location.origin}/env-config.js`);
};
